import { ROLES } from '../constants'
import { useHasRole } from './use-has-role'
import { useHasActiveSKU } from './use-has-valid-sku'

/**
 * Check if user has Analyst role AND an active SKU
 */
export const useHasActiveAnalyst = (): boolean => {
	const hasRole = useHasRole(ROLES.Analyst)
	const hasActiveSKU = useHasActiveSKU()
	return hasRole && hasActiveSKU
}
